import React, { useState } from "react";
import CardMonth from "./Consumi/Cards/CardMonth";
import CardWeek from "./Consumi/Cards/CardWeek";
import CardYear from "./Consumi/Cards/CardYear";
import FasciaMonth from "./Consumi/Fasce/FasciaMonth";
import FasciaWeek from "./Consumi/Fasce/FasciaWeek";
import FasciaYear from "./Consumi/Fasce/FasciaYear";
import ListaMonth from "./Consumi/Liste/ListaMonth";
import ListaWeek from "./Consumi/Liste/ListaWeek";
import ListaYear from "./Consumi/Liste/ListaYear";
import { useSelector } from "react-redux";
import ReactCardFlip from 'react-card-flip';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// import {
//   setData as setMonthData,
//   setFasce as setMonthFasce,
//   setKwhAvg as setMonthKwhAvg,
//   setKwhMax as setMonthKwhMax,
//   setSpesaAvg as setMonthSpesaAvg,
//   setSpesaMax as setMonthSpesaMax,
//   setPriceKwhAvgMonth
// } from "../features/dataMonthSlice";
// import {
//   setData as setWeekData,
//   setFasce as setWeekFasce,
//   setKwhAvg as setWeekKwhAvg,
//   setKwhMax as setWeekKwhMax,
//   setSpesaAvg as setWeekSpesaAvg,
//   setSpesaMax as setWeekSpesaMax,
//   setPriceKwhAvgWeek
// } from '../features/dataWeekSlice';
// import {
//   setData as setYearData,
//   setFasce as setYearFasce,
//   setKwhAvg as setYearKwhAvg,
//   setKwhMax as setYearKwhMax,
//   setSpesaAvg as setYearSpesaAvg,
//   setSpesaMax as setYearSpesaMax,
//   setPriceKwhAvgYear,
// } from '../features/dataYearSlice';

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Controller, Pagination } from 'swiper';
import "swiper/swiper.min.css";
import Letture from "./Consumi/_Letture";

// install Swiper's Controller component
SwiperCore.use([Controller, Pagination]);

function SliderConsumi() {
  const [controlledSwiper, setControlledSwiper] = useState(null);
  // const dispatch = useDispatch();
  // const dataMonth = useSelector((user) => user.dataMonth);
  // const dataWeek = useSelector((user) => user.dataWeek);
  // const customerId = useSelector((user) => user.user.info.customer_id);
  // const podCode = useSelector((user) => user.user.info.pod_code);
  // const token = useSelector((user) => user.user.info.token_value);
  // const userToken = useSelector((user) => user.user.info.user_id);
  const view = useSelector((user) => user.settings.view);

  const [onFullscreen, setOnFullscreen] = useState({ visible: false });
  const [flipped, setFlipped] = useState(false)

  /* const updateMonth = async () => {
    let { dataStart, dataEnd } = dataMonth;
    const url = `https://www.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dataStart}&date_end=${dataEnd}`;
    const { data: { data } } = await axios.get(url);
    // data update
    const result = data.consumptions;
    const kwhAvg = data.kwhAvgMese;
    const kwhMax = data.kwhMaxMese;
    const spesaAvg = data.spesaAvgMese;
    const spesaMax = data.spesaMaxMese;
    const f1 = data.total_f1.toFixed(2);
    const f2 = data.total_f2.toFixed(2);
    const f3 = data.total_f3.toFixed(2);
    const priceKwhAvg = data.costo_kwh;
    dispatch(setMonthData(result));
    dispatch(setMonthKwhAvg(kwhAvg));
    dispatch(setMonthKwhMax(kwhMax));
    dispatch(setMonthSpesaAvg(spesaAvg));
    dispatch(setMonthSpesaMax(spesaMax));
    dispatch(setMonthFasce([f1, f2, f3]));
    dispatch(setPriceKwhAvgWeek(priceKwhAvg));
    dispatch(setPriceKwhAvgMonth(priceKwhAvg));
    dispatch(setPriceKwhAvgYear(priceKwhAvg));
  };

  const updateYear = async () => {
    const url = `https://www.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryRevo.php?customer_id=${customerId}&user_id=${userToken}&token=${token}&pod_code=${podCode}`;
    const { data } = await axios.get(url);
    // data update
    const f1 = data.fasce_anno_corrente.total_f1.toFixed(2);
    const f2 = data.fasce_anno_corrente.total_f2.toFixed(2);
    const f3 = data.fasce_anno_corrente.total_f3.toFixed(2);
    dispatch(setYearData(data.data.slice(0, 12)));
    dispatch(setYearSpesaMax(data.max_euro));
    dispatch(setYearSpesaAvg(data.media_euro));
    dispatch(setYearKwhAvg(data.media_kwh));
    dispatch(setYearKwhMax(data.max_kwh));
    dispatch(setYearFasce([f1, f2, f3]));
  };

  const updateWeek = async () => {
    const { dataStart, dataEnd } = dataWeek;
    const url = `https://www.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryDayNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dataStart}&date_end=${dataEnd}`;
    const { data: { data } } = await axios.get(url);
    // data update
    const result = data.consumptions;
    const kwhAvg = data.kwhAvg;
    const kwhMax = data.kwhMax;
    const spesaAvg = data.spesaAvg;
    const spesaMax = data.spesaMax;
    const f1 = data.total_f1;
    const f2 = data.total_f2;
    const f3 = data.total_f3;
    dispatch(setWeekData(result));
    dispatch(setWeekKwhAvg(kwhAvg));
    dispatch(setWeekKwhMax(kwhMax));
    dispatch(setWeekSpesaMax(spesaMax));
    dispatch(setWeekSpesaAvg(spesaAvg));
    dispatch(setWeekFasce([f1, f2, f3]));
  }; */

  const pagination = {
    "clickable": true,
    "bulletClass": "item",
    "bulletActiveClass": "item-active",
    "renderBullet": function (index, className) {
      const label = index === 0 ? "Mese" : index === 1 ? "Anno" : "Settimana";
      return '<span class="' + className + '">' + (label) + '</span>';
    }
  }

  return (
    <div className="sliderConsumiWrapper">
      <Swiper initialSlide={view} pagination={pagination} controller={{ control: controlledSwiper }} slidesPerView={1} spaceBetween={-25} grabCursor={true}>
        <SwiperSlide >
          <div style={{paddingBottom: 41}}>
            <CardMonth index={0} {...{ onFullscreen, setOnFullscreen }} />
          </div>
        </SwiperSlide>
        <SwiperSlide >
          <CardYear index={1} />
        </SwiperSlide>
        <SwiperSlide >
          <CardWeek index={2} />
        </SwiperSlide>
      </Swiper>
        <p className="infoScroll">
          Scorri o clicca per passare al tipo di periodo che vuoi visualizzare
        </p>

      <Swiper onSwiper={setControlledSwiper} allowSlideNext={false} allowSlidePrev={false} slidesPerView={1} spaceBetween={-20} grabCursor={true} className='sliderCard'>
        <SwiperSlide className='slider1'>
          <div className="fasce">
            <FasciaMonth />
          </div>
          <div className="label_refresh">
            <p>Tabella consumi e spesa</p>
            {/* <div className="iconRefresh" onClick={updateMonth}>
              <CachedIcon />
            </div> */}
          </div>
          <div className="liste">
            <ListaMonth />
          </div>
        </SwiperSlide>
        <SwiperSlide >
          <div className="fasce">
            <FasciaYear />
          </div>
          <div className="label_refresh">
            <p>Tabella consumi e spesa</p>
            {/* <div className="iconRefresh" onClick={updateYear}>
              <CachedIcon />
            </div> */}
            <div className="switchLetture" onClick={() => setFlipped(!flipped)}>
              {flipped ? <p>Torna ai consumi <ArrowForwardIosIcon /></p> : <p>Guarda le letture <ArrowForwardIosIcon /></p>}
            </div>
          </div>
          <ReactCardFlip isFlipped={flipped} flipDirection="horizontal">
            <div className='liste'>
              <ListaYear/>
            </div>
            <div className='liste letture'>
              <Letture />
            </div>
          </ReactCardFlip>
        </SwiperSlide>
        <SwiperSlide >
          <div className="fasce">
            <FasciaWeek />
          </div>
          <div className="label_refresh">
            <p>Tabella consumi e spesa</p>
            {/* <div className="iconRefresh" onClick={updateWeek}>
              <CachedIcon />
            </div> */}
          </div>
          <div className="liste">
            <ListaWeek />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default SliderConsumi;
